import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	/* 关于我们 */
	{
		path: '/introduction', //中心简介
		name: 'introduction',
		component: () =>
			import('../views/about/introduction.vue')
	},
	{
		path: '/address', //地址导航
		name: 'address',
		component: () =>
			import('../views/about/address.vue')
	},
	/* 公告信息*/
	{
		path: '/risk', //风险信息
		name: 'risk',
		component: () =>
			import('../views/notice/risk.vue')
	},
	{
		path: '/business', //业务动态
		name: 'business',
		component: () =>
			import('../views/notice/business.vue')
	},
	{
		path: '/businessdetails', //业务动态详情
		name: 'businessdetails',
		component: () =>
			import('../views/notice/businessdetails.vue')
	},
	{
		path: '/notice', //企业公告
		name: 'notice',
		component: () =>
			import('../views/notice/notice.vue')
	},
	/* 开户操作*/
	{
		path: '/login', //开户登录
		name: 'login',
		component: () =>
			import('../views/serviceRegister/login.vue')
	},
	{
		path: '/agreement', //开户协议
		name: 'agreement',
		component: () =>
			import('../views/serviceRegister/agreement.vue')
	},
	{
		path: '/identity', //开户验证
		name: 'identity',
		component: () =>
			import('../views/serviceRegister/identity.vue')
	},
	/* 登录及忘记密码,修改密码*/
	{
		path: '/register', //普通登录
		name: 'register',
		component: () =>
			import('../views/register/register.vue')
	},
	{
		path: '/forget', //忘记密码-输入股东账户
		name: 'forget',
		component: () =>
			import('../views/register/forget.vue')
	},
	{
		path: '/obtaincode', //忘记密码-获取手机验证码 密码重置
		name: 'obtaincode',
		component: () =>
			import('../views/register/obtaincode.vue')
	},
	{
		path: '/changepassword', //修改密码-密码重置
		name: 'changepassword',
		component: () =>
			import('../views/register/changepassword.vue')
	},
	/* 实名认证*/
	{
		path: '/attestationlogin', //登录
		name: 'attestationlogin',
		component: () =>
			import('../views/certification/login.vue'),
		meta: {
			title: '成都托管中心-实名认证'
		}
	},
	{
		path: '/attestationidentity', //身份证验证
		name: 'attestationidentity',
		component: () =>
			import('../views/certification/identity.vue')
	},
	/* 账户查询*/
	{
		path: '/queryindex', //账户查询首页
		name: 'queryindex',
		component: () =>
			import('../views/query/index.vue')
	},
	{
		path: '/sharesdetails', //股份查询
		name: 'sharesdetails',
		component: () =>
			import('../views/query/sharesdetails.vue')
	},
	{
		path: '/dividenddetails', //红利查询
		name: 'dividenddetails',
		component: () =>
			import('../views/query/dividenddetails.vue')
	},
	{
		path: '/detailed', //明细查询(今日和历史)
		name: 'detailed',
		component: () =>
			import('../views/query/detailed.vue')
	},
	/* 我的申请*/
	{
		path: '/myindex', //我的申请
		name: 'myindex',
		component: () =>
			import('../views/my/myindex.vue')
	},
	{
		path: '/mylist', //申请列表
		name: 'mylist',
		component: () =>
			import('../views/my/mylist.vue')
	},
	{
		path: '/mydetails', //申请列表
		name: 'mydetails',
		component: () =>
			import('../views/my/mydetails.vue')
	},
	/* 业务申请 */
	{
		path: '/businessindex', //业务申请分类选择
		name: 'businessindex',
		component: () =>
			import('../views/business/index.vue')
	},
	/* 业务申请-红利领取 */
	{
		path: '/applydividend', //红利申请详情
		name: 'applydividend',
		component: () =>
			import('../views/business/applydividend.vue')
	},
	{
		path: '/bankCardList', //银行卡列表
		name: 'bankCardList',
		component: () =>
			import('../views/business/bankCardList.vue')
	},
	{
		path: '/addcard', //添加银行卡
		name: 'addcard',
		component: () =>
			import('../views/business/addcard.vue')
	},
	{
		path: '/addSuccess', //添加银行卡成功
		name: 'addSuccess',
		component: () =>
			import('../views/business/addSuccess.vue')
	},
	{
		path: '/sqSuccess', //提交红利申请成功
		name: 'sqSuccess',
		component: () =>
			import('../views/business/sqSuccess.vue')
	},
	{
		path: '/cardtisp', //默认卡修改提示
		name: 'cardtisp',
		component: () =>
			import('../views/business/cardtisp.vue')
	},
	/* 业务申请-股权过出 */
	{
		path: '/stockout', //股权过出
		name: 'stockout',
		component: () =>
			import('../views/business/stockout.vue')
	},

	/* 业务申请-股权过入 */
	{
		path: '/stockover', //股权过入
		name: 'stockover',
		component: () =>
			import('../views/business/stockover.vue')
	},
	/* 业务申请-股权质押 */
	{
		path: '/pledge', //股权质押
		name: 'pledge',
		component: () =>
			import('../views/business/pledge.vue')
	},
	/* 业务申请-股权解除质押 */
	{
		path: '/Relievepledge', //股权解除质押
		name: 'Relievepledge',
		component: () =>
			import('../views/business/Relievepledge.vue')
	},
	/* 业务申请公共部分 */
	{
		path: '/businessnotice', //业务申请须知
		name: 'businessnotice',
		component: () =>
			import('../views/business/notice.vue')
	},
	{
		path: '/loadermaterial', //申请材料上传
		name: 'loadermaterial',
		component: () =>
			import('../views/business/loadermaterial.vue')
	},
	{
		path: '/formdata', //申请表单数据检查
		name: 'formdata',
		component: () =>
			import('../views/business/formdata.vue')
	},
	{
		path: '/msghtml', //公共提示页面
		name: 'msghtml',
		component: () =>
			import('../views/msghtml.vue')
	},
	{
		path: '/plypay', //支付页面
		name: 'plypay',
		component: () =>
			import('../views/plypay.vue')
	},
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})
router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title
	}
	next()
})
export default router
